/**
 * Generic link cell renderer for the Buildings listing.
 *
 * Renders any row field that provides a path property (e.g. account with accountPath).
 * Used for the Account column (accountName + accountPath).
 *
 * Quimby Table renderer signature: ({ item, dataKey, index }) => ReactNode
 */
import React from 'react';
/**
 * Renders the account cell as a link using accountPath.
 * Falls back to plain text when accountPath is absent.
 */
export function BuildingAccountCellRenderer({ item }) {
    var _a;
    if (item.accountPath) {
        return React.createElement("a", { href: item.accountPath }, item.accountName);
    }
    return React.createElement(React.Fragment, null, (_a = item.accountName) !== null && _a !== void 0 ? _a : null);
}
